var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M49.1 43q.9.9.9 2.1t-.9 2l-2 2q-.8.9-2 .9t-2.1-.9l-9.3-9.3q-6.3 4.2-14 3.5T6.4 37Q0 30.6 0 21.7T6.4 6.2 21.8 0t15.3 6.4q5.6 5.5 6.3 13.3t-3.6 14zM9.6 33.8q5.1 5 12.2 5t12.1-5 5-12.1-5-12.1-12.1-5-12.2 5-5 12.1 5 12.1z"}));
}

SearchIconInline.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
